import { FC, ReactNode } from "react";
import { Header } from "components";

import { Box, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

export type LayoutProps = {
  children?: ReactNode;
};

export const StyledLayout = styled(Box)(({ theme }) => {
  return {
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.background.primary,
  };
});

const StyledContentWrap = styled(Box)(() => {
  return {
    margin: "0 auto",
    width: "100%",
    minHeight: "100vh",
    position: "relative",
  };
});

const Layout: FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  return (
    <StyledLayout>
      <StyledContentWrap>
        <Header />
        <Box px={3} py={2.5} maxWidth={theme.layout.contentMaxWidth} margin="0 auto">{children}</Box>
      </StyledContentWrap>
    </StyledLayout>
  );
};

export default Layout;
